import type {StyleFunctionProps} from '@chakra-ui/styled-system';

import {defineGraphNodeCSSVars} from './helpers';
import {nodeHeadingCSSVars} from './node-heading-theme';

export const {
  headingSize: $headingSize,
  headingWeight: $headingWeight,
  headingColor: $textColor,
  bgColor: $bgColor,
  borderWidth: $borderWidth,
  borderColor: $borderColor,
  primaryIconSize: $primaryIconSize,
  iconBgColor: $iconBgColor,
  borderRadius: $borderRadius,
  highlightColor: $highlightColor,
  childrenPadding: $childrenPadding,
} = defineGraphNodeCSSVars(``, [
  `headingSize`,
  `headingWeight`,
  `headingColor`,
  `bgColor`,
  `borderWidth`,
  `borderColor`,
  `primaryIconSize`,
  `iconBgColor`,
  `borderRadius`,
  `highlightColor`,
  `childrenPadding`,
]);

// Exported for use in the GraphContainer (top level component)
export const nodeCSSVars = (props: StyleFunctionProps) => ({
  ...nodeHeadingCSSVars(props),
  // Self CSS Vars
  [$bgColor.variable]: `colors.background.primary`,
  [$borderWidth.variable]: `2px`,
  [$borderRadius.variable]: `radii.2xl`,
  [$primaryIconSize.variable]: `space.space-500`,
  [$iconBgColor.variable]: `colors.background.secondary`,
  [$childrenPadding.variable]: `8`,
});
